import { render, staticRenderFns } from "./MonitorStatusItems.vue?vue&type=template&id=fbf6f538"
import script from "./MonitorStatusItems.vue?vue&type=script&lang=js"
export * from "./MonitorStatusItems.vue?vue&type=script&lang=js"
import style0 from "./MonitorStatusItems.vue?vue&type=style&index=0&id=fbf6f538&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbf6f538')) {
      api.createRecord('fbf6f538', component.options)
    } else {
      api.reload('fbf6f538', component.options)
    }
    module.hot.accept("./MonitorStatusItems.vue?vue&type=template&id=fbf6f538", function () {
      api.rerender('fbf6f538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MonitorStatusItems.vue"
export default component.exports